import { useEffect, RefObject } from 'react'
import { ModalType } from '../core/enums/Modals'

export const useOutsideClick = (ref: RefObject<HTMLElement>, callback: () => void, type?: ModalType) => {
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent | TouchEvent) => {
			if (!(event.target instanceof Element)) return

			switch (type) {
				case ModalType.User:
					if (!event.target.closest('.user-profile') && ref.current && !ref.current.contains(event.target)) {
						callback()
					}
					break

				case ModalType.Balance:
					if (!event.target.closest('.wallet-balance') && !event.target.closest('.points-balance') && ref.current && !ref.current.contains(event.target)) {
						callback()
					}
					break

				case ModalType.Inbox:
					if (!event.target.closest('.inbox-btn') && ref.current && !ref.current.contains(event.target)) {
						callback()
					}
					break

				case ModalType.BottomMenu:
					if (!event.target.closest('.bottom-menu-item.burger') && ref.current && !ref.current.contains(event.target)) {
						callback()
					}
					break

				case ModalType.Promo:
					if (!event.target.closest('.popping-circle') && ref.current && !ref.current.contains(event.target)) {
						callback()
					}
					break

				default:
					if (ref.current && !ref.current.contains(event.target)) {
						callback()
					}
					break
			}
		}

		const isIPhone = /iPhone/.test(navigator.userAgent)

		if (isIPhone) {
			document.addEventListener('touchstart', handleClickOutside)
		} else {
			document.addEventListener('click', handleClickOutside)
		}

		return () => {
			if (isIPhone) {
				document.removeEventListener('touchstart', handleClickOutside)
			} else {
				document.removeEventListener('click', handleClickOutside)
			}
		}
	}, [ref, callback, type])
}
